export const JOB_TIME_PICKER_PRESETS = [
    {label: 'Early morning', values: ['04:00', '04:30', '05:00', '05:30', '06:00', '07:00']},
    {label: 'Morning', values: ['08:00', '09:00', '10:00', '11:00']},
    {label: 'Midday', values: ['12:00', '13:00', '14:00']},
    {label: 'Afternoon', values: ['15:00', '16:00', '17:00']},
    {label: 'Evening', values: ['18:00', '19:00', '20:00']},
    {label: 'Night', values: ['21:00', '22:00', '23:00']},
    {label: 'Overnight', values: ['00:00', '01:00', '02:00', '03:00']},
] as const
